module.exports = __webpack_public_path__ + "img/Canary Islands.f56c75f9.svg";